import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Section } from "../../../../components/CustomLayout/CustomLayoutStyles";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import TittleLine from "../../../../components/Common/TittleLine";
import CustomSeparator from "../../../../components/Common/CustomSeparator";
import DashboardDisclaimer from "../../../dashboard/components/DashboardDisclaimer";
import styled from "styled-components";
import standVirtualRoutes from "../../standVirtualRoutes";
import { PowerBIContainer } from "../../styles/MainLayoutStandVirtualStyles";
import usePermissions from "../../../../hooks/usePermissions";
import { POWER_BI_DASHBOARD } from "../../constantes";

const VerticalButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  width: 100%;

  & > * {
    flex: 1;
  }
`;

const StandVirtualDashboardScreen = ({ authUserData }) => {
  const history = useHistory();
  const { hasAnyPermission, isMaster, isAdmin, isMonitor } = usePermissions();

  const goTo = (screen) => {
    history.push(screen);
  };

  const availableRoutes = Object.entries(standVirtualRoutes.dashboard)
    .filter(([key]) => key !== "main")
    .filter(([key, routeConfig]) => {
      // Si la ruta no tiene permisos requeridos, se muestra
      if (
        !routeConfig.requiredPermissions ||
        routeConfig.requiredPermissions.length === 0
      ) {
        return true;
      }
      // Si tiene permisos requeridos, verificar que el usuario tenga al menos uno
      return hasAnyPermission(routeConfig.requiredPermissions);
    });

  const getUserWelcomeMessage = () => {
    const userName = authUserData?.prestador?.nombre || "Usuario";

    if (isMaster) {
      return {
        title: `Hola ${userName} - ROL MASTER`,
        text: "Tienes acceso completo: Administra usuarios, configura Stand Virtual y accede a todos los reportes",
      };
    } else if (isAdmin) {
      return {
        title: `Hola ${userName} - ROL ADMINISTRADOR`,
        text: "Configura Stand Virtual y accede a reportes. No puedes gestionar usuarios",
      };
    } else if (isMonitor) {
      return {
        title: `Hola ${userName} - ROL MONITOR`,
        text: "Visualiza configuraciones y accede a reportes. Acceso de solo lectura",
      };
    } else {
      return {
        title: `Hola ${userName}`,
        text: "Bienvenido al Stand Virtual",
      };
    }
  };



  const welcomeMessage = getUserWelcomeMessage();

  return (
    <>
      <CustomSeparator height={"20px"} />

      <Section>
        <DashboardDisclaimer
          title={welcomeMessage.title}
          text={welcomeMessage.text}
        />
      </Section>

      <CustomSeparator height={"30px"} />

      <Section>
        <TittleLine title={"Configuración Stand Virtual"} weight={"bold"} />
      </Section>

      <Section>
        <VerticalButtonsContainer>
          {availableRoutes.map(([key, routeConfig]) => (
            <CustomButton
              key={key}
              label={routeConfig.name}
              isLoading={false}
              height={"auto"}
              weight={"bold"}
              onClick={() => {
                goTo(`/${standVirtualRoutes.base.route}/${routeConfig.route}`);
              }}
            />
          ))}
        </VerticalButtonsContainer>
      </Section>

      <CustomSeparator height={"30px"} />
      <Section>
          <PowerBIContainer>
            <iframe
              title={POWER_BI_DASHBOARD.title}
              src={POWER_BI_DASHBOARD.url}
              allowFullScreen={true}
            />
          </PowerBIContainer>
      </Section>          
    </>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(StandVirtualDashboardScreen);
